import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PATH_BILLING } from '@/routes/consts'
import { PanelRoot } from '../panel'
import { Payment } from '../payment'

export const BillingRoot = () => {
  return (
    <Routes>
      <Route index path={'/*'} element={<PanelRoot />} />

      <Route path={PATH_BILLING.PAYMENT} element={<Payment />} />

      <Route path={'*'} element={<Navigate to={'/'} replace={true} />} />
    </Routes>
  )
}
